import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { storage } from '@uhg-abyss/web/tools/storage';
import moment from 'moment';
import { RESET_TIME } from '../constants';

export const IdleTimer = ({
  events,
  eventTimeout,
  idleTimeout,
  onActive,
  onIdle,
  modalOpen,
  children,
}) => {
  let idleTimer;
  let eventTimer;

  const resetTimer = (event, timeDiff) => {
    if (!eventTimer || timeDiff) {
      if (!timeDiff) {
        storage.local.set(RESET_TIME, moment().add(idleTimeout, 'ms'));
      }

      clearTimeout(idleTimer);
      const timeoutTime = idleTimeout;
      idleTimer = setTimeout(() => {
        idleTimer = null;
        // eslint-disable-next-line no-use-before-define
        onTimerIdle();
      }, timeDiff || timeoutTime);

      clearTimeout(eventTimer);
      eventTimer = setTimeout(() => {
        eventTimer = null;
      }, eventTimeout);

      onActive();
    }
  };

  const addListeners = () => {
    events.forEach((e) => {
      return document.addEventListener(e, resetTimer);
    });
  };

  const removeListeners = () => {
    events.forEach((e) => {
      return document.removeEventListener(e, resetTimer);
    });
    clearTimeout(idleTimer);
    clearTimeout(eventTimer);
  };

  const onTimerIdle = () => {
    const storedTime = moment(storage.local.get(RESET_TIME));
    const now = moment();

    if (storedTime.isAfter(now)) {
      const timeDiff = storedTime.diff(now, 'milliseconds');
      resetTimer(null, timeDiff);
    } else {
      idleTimer = null;
      removeListeners();
      onIdle();
    }
  };

  useEffect(() => {
    addListeners();
    resetTimer();

    return () => {
      removeListeners();
    };
  }, []);

  useEffect(() => {
    if (!modalOpen) {
      addListeners();
      resetTimer();
    }
  }, [modalOpen]);

  return children;
};

IdleTimer.propTypes = {
  children: PropTypes.node,
  eventTimeout: PropTypes.number.isRequired,
  idleTimeout: PropTypes.number.isRequired,
  events: PropTypes.arrayOf(PropTypes.string),
  onActive: PropTypes.func,
  onIdle: PropTypes.func,
};

IdleTimer.defaultProps = {
  children: null,
  events: [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'scroll',
    'MSPointerDown',
    'MSPointerMove',
  ],
  onActive: () => {
    return null;
  },
  onIdle: () => {
    return null;
  },
};
